import { Injectable } from '@angular/core';
import { SiDataService } from '../../services/si-data.service';

@Injectable({
  providedIn: 'root'
})
export class KpiGroupService {

  constructor(private siDataService: SiDataService) { }
}
